module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('SegmentButtons', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "itemUpdated": function($event) {
        return _vm.$emit('itemUpdated')
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("SGR" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field"
  }, [_vm._v("SG" + _vm._s(_vm.item.segment.id) + " " + _vm._s(_vm.item.segment.name))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Rate")]), _c('div', {
    staticClass: "field"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'configuration-rate',
        params: {
          id: _vm.item.reservation_rate.id
        }
      }
    }
  }, [_c('span', [_vm._v("RR" + _vm._s(_vm.item.reservation_rate.id) + " " + _vm._s(_vm.item.reservation_rate.name))])])], 1)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec1567e8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/SegmentRate.vue
// module id = 2742
// module chunks = 1